import * as Scrivito from "scrivito";

const MarkerWidget = Scrivito.provideWidgetClass("MarkerWidget", {
  onlyInside: "OpenStreetMapWidget",
  attributes: {
    address: "string",
    lat: "float",
    lon: "float",
    headline: "string",
    content: "html",
    link: "link",
    color: [
      "enum",
      {
        values: ["blue", "light-blue", "teal", "light-teal", "yellow", "gray"],
      },
    ],
  },
  extractTextAttributes: ["content", "address"],
});

export default MarkerWidget;
